// extracted by mini-css-extract-plugin
module.exports = {"teamMemberList":"TeamMemberList-module_teamMemberList_f0c4a"};